/*!
 * Modified from long-press-event.js
 * Original can be found at
 * https://github.com/john-doherty/long-press-event
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */

import MobileDetect from "mobile-detect";

const defaultDelay = 500;

export function fireLongPressEvent(e: Element, isRightClick: boolean): void {
    e.dispatchEvent(new CustomEvent("long-press", { bubbles: true, cancelable: true, detail: { isRightClick } }));
}

export const longPressTargetClass = "takes-long-press";

const isMobile = new MobileDetect(window.navigator.userAgent).mobile() !== null;
const useTouchForLongPress =
    isMobile && ("ontouchstart" in window || navigator.maxTouchPoints > 0 || (navigator as any).msMaxTouchPoints > 0);

export function registerLongPress(window: any, document: Document) {
    let timer: number | undefined;

    const mouseDown = useTouchForLongPress ? "touchstart" : "mousedown";
    const mouseOut = useTouchForLongPress ? "touchcancel" : "mouseout";
    const mouseUp = useTouchForLongPress ? "touchend" : "mouseup";
    const mouseMove = useTouchForLongPress ? "touchmove" : "mousemove";

    const mouseWheel = "mousewheel";
    const wheel = "wheel";
    const scrollEvent = "scroll";

    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window.CustomEvent !== "function") {
        window.CustomEvent = (event: string, params: any) => {
            params = params ?? { bubbles: false, cancelable: false, detail: undefined };

            const evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };

        window.CustomEvent.prototype = window.Event.prototype;
    }

    function clear() {
        clearTimeout(timer);
        timer = undefined;
    }

    document.addEventListener(mouseDown, e => {
        const el = e.target as Element;

        if (el !== null) {
            const delayAttribute = el.getAttribute("data-long-press-delay");
            const specifiedDelay = delayAttribute === null ? null : parseInt(delayAttribute, 10);
            const longPressDelayInMs = specifiedDelay === null || isNaN(specifiedDelay) ? defaultDelay : specifiedDelay;
            timer = setTimeout(
                (() => {
                    fireLongPressEvent(el, false);
                    clear();
                }) as TimerHandler,
                longPressDelayInMs
            );
        }
    });

    document.addEventListener(mouseUp, clear);
    document.addEventListener(mouseOut, clear);
    document.addEventListener(mouseMove, clear);
    document.addEventListener(mouseWheel, clear);
    document.addEventListener(wheel, clear);
    document.addEventListener(scrollEvent, clear);
}
